import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { ExcessWithTooltip } from '../common/excess_with_tooltip';
import { ProductDocuments } from '../common/product_documents';
import { Separator } from '../common/separator';
import { withQuoteFlatten } from '../common/with_quote_flatten';

import { IsThisProductSuitableForMe } from '../common/is_this_product_suitable_for_me';

const useStyles = createUseStyles((theme) => ({
    container: {
        minHeight: theme.spacing[48],
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-evenly',
        marginBottom: theme.spacing[8]
    },
    excess: {
        flex: 2,
        justifyContent: 'center',
        display: 'flex'
    },
    tmd: {
        flex: 1,
        justifyContent: 'center',
        display: 'flex',
        fontWeight: theme.fontWeight.semibold
    },
    pds: {
        flex: 1,
        justifyContent: 'center',
        display: 'flex'
    }
}));

// eslint-disable-next-line valid-jsdoc
const _ProductAdditionalXs = (props) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });
    const { className, productExcess, quote } = props;

    return (
        <div className={classNames('test-policyProductCard-additional-xs', classes.container, className)}>
            <div className={classes.excess}><ExcessWithTooltip productExcess={productExcess} /></div>
            <Separator type="vertical" insideFlexbox />
            <div className={classes.tmd}><IsThisProductSuitableForMe className={classes.productSuitable} quote={quote}>TMD</IsThisProductSuitableForMe></div>
            <Separator type="vertical" insideFlexbox />
            <div className={classes.pds}><ProductDocuments quote={quote} /></div>
        </div>
    );
};

_ProductAdditionalXs.propTypes = {
    className: PropTypes.string,
    quote: PropTypes.object,
    productExcess: PropTypes.number
};

const ProductAdditionalXs = withQuoteFlatten(_ProductAdditionalXs);

export { ProductAdditionalXs };
